/**
 * Health check endpoint
 */

import type { RouteContext } from '../types';

export async function healthHandler(context: RouteContext): Promise<any> {
  const { config, requestId } = context;

  // Basic health information
  const health = {
    status: 'healthy',
    version: '1.1.0',
    timestamp: new Date().toISOString(),
    uptime: process.uptime(),
    features: {
      tasks: config.features?.tasks !== false,
      files: config.features?.files !== false,
      realtime: config.features?.realtime !== false,
      ai: config.features?.ai === true,
    },
    configuration: {
      scanPaths: config.scanPaths?.length || 0,
      cacheEnabled: config.cache?.enabled !== false,
      corsEnabled: config.security?.cors !== false,
    },
    environment: {
      nodeVersion: process.version,
      platform: process.platform,
      environment: process.env.NODE_ENV || 'development',
    },
  };

  return health;
}